import store from "../../../../Vue/Modules/Location/Core/Site/store";

window.frontend_location_vue_instance = new Vue({
    store,
    el: '.location-module'
});